import {
  RELEVANT_MODES,
  RelevantModeState,
  UserDefinedValue,
  UserDefinedValueWithCustomId,
} from '../types';

export const getRelevantModeIds = (
  relevantModes: UserDefinedValue[] | undefined | null
): string[] => {
  if (!relevantModes || relevantModes?.length === 0 || !Array.isArray(relevantModes))
    return [RELEVANT_MODES.DO_NOT_RESTRICT];

  const ids: string[] = [];

  relevantModes?.forEach((mode, index) => {
    ids.push(`${mode?.tagId}_${mode?.value}`);
  });

  return ids;
};

export const getEntireRelevantModes = (
  ids: string[],
  relevantModeState: RelevantModeState
): UserDefinedValueWithCustomId[] | undefined => {
  const relevantModes: UserDefinedValueWithCustomId[] = [];

  ids.forEach((id) => {
    const relevantMode = relevantModeState.values.find((value) => value.id === id);
    if (relevantMode) relevantModes.push(relevantMode);
  });

  return relevantModes;
};
